//Permet d'ajout les variables window.etc...
declare global {
    interface Window {
        env: any;
    }
}

// Permet de définir les variables utiles
type EnvType = {
    REACT_APP_NUMBER_ELEMENT_TABLE: number;
    REACT_APP_NUMBER_ELEMENT_TABLE_SMALL: number;
    REACT_APP_NUMBER_ELEMENT_TABLE_ADMIN: number;
    REACT_APP_URL_BACK_AEL: string;
    REACT_APP_URL_AEL: string;
    REACT_APP_URL_VALIDATION_ACCOUNT: string;
    REACT_APP_GESTION_ALERTE_FUITE_DUREE: number;
    REACT_APP_THEME: string;
};
//Export d'env avec les attributs utiles
export const env: EnvType = { ...process.env, ...window.env };
